import React, { Component } from 'react';

import logoUrl from '../lendnation-logo-v2.svg';

class Logo extends Component {
  render() {
    return (
      <header className="App-header">
        <div align="center">
          <a href="https://www.lendnation.com">
            <img
              src={logoUrl}
              alt="LendNation"
              className="img-responsive logo-img"
            />
          </a>
        </div>
      </header>
    );
  }
}
export default Logo;
